// @ts-nocheck
// Store Custom Widget
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

const enum fields {
    expanded = "expanded",
    title = "title",
    headingStyle = "headingStyle",
}

interface OwnProps extends WidgetProps {
    extendedStyles?: AccordionStyles;
    fields: {
        [fields.expanded]: boolean;
        [fields.title]: string;
        [fields.headingStyle]: string;
    };
}

export interface AccordionStyles {
    accordionSectionStyles?: AccordionSectionPresentationProps;
}

export const accordionStyles: AccordionStyles = {
    accordionSectionStyles: {
        titleTypographyProps: {
            css: css`
                margin-bottom: 0;
            `,
        },
    },
};

const styles = accordionStyles;

const AccordionStore: FC<OwnProps> = ({ fields, id }) => {
    const [expandAccordion, setExpandAccordion] = useState(fields.expanded);

    useEffect(() => {
        setExpandAccordion(fields.expanded);
    }, [fields.expanded]);

    const accordionSection = {
        titleTypographyProps: {
            variant: fields.headingStyle as any,
            css: css`
                ${styles.accordionSectionStyles?.titleTypographyProps?.css}
            `,
        },
    };

    return (
        <Accordion headingLevel={2}>
            <AccordionSection
                {...accordionSection}
                title={fields.title}
                expanded={expandAccordion}
                onTogglePanel={() => setExpandAccordion(!expandAccordion)}
            >
                <Zone contentId={id} zoneName="Content"></Zone>
            </AccordionSection>
        </Accordion>
    );
};

const headingOptions = [
    { displayName: "Heading 1", value: "h1" },
    { displayName: "Heading 2", value: "h2" },
    { displayName: "Heading 3", value: "h3" },
    { displayName: "Heading 4", value: "h4" },
    { displayName: "Heading 5", value: "h5" },
    { displayName: "Heading 6", value: "h6" },
];

const widgetModule: WidgetModule = {
    component: AccordionStore,
    definition: {
        group: "Basic",
        displayName: "Accordion",
        icon: "list-dropdown",
        fieldDefinitions: [
            {
                name: fields.expanded,
                displayName: "Expand accordion",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: true,
                variant: "toggle",
            },
            {
                name: fields.title,
                displayName: "Accordion Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                fieldType: "General",
                name: fields.headingStyle,
                displayName: "Heading Display Style",
                editorTemplate: "DropDownField",
                options: headingOptions,
                defaultValue: "h2",
            },
        ],
    },
};

export default widgetModule;
